<template>
    <div class="entry-content">
        <UserStatsCards />
        <userTable />
    </div>
</template>

<script>
	import userTable from '@/components/userTable/index'
	import UserStatsCards from '@/components/userTable/UserStatsCards'

	export default {
		name: "Individuals",
		components: {
			userTable,
			UserStatsCards
		}
	}
</script>

<style scoped>

</style>
